var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'join-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      savingFlag: false,
      join: {
        join_class: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        join_class: !!this.join.join_class,
        not_input: !!this.join.join_class
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('JOIN_CREATE',
          { data: this.join, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/joins', query: { type: this.$router.currentRoute.query.type}})
    },
    half: function () {
      this.join.join_class = utils.emHalf(this.join.join_class)
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/joins')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/join-new.js